export class Banco {
    public Id: number;
    public Numero: string;
    public Nome: string;
    public Ativo: boolean;

    constructor() {
        this.Ativo = true;
        this.Id = 0;
    }
}